module.exports = __webpack_public_path__ + "static/media/money-history-icon.926399f9.svg";